import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import DepartmentSelector from './DepartmentSelector';
import { useAuth } from '../context/AuthContext';
import '../styles/neumorphism.css';

const { FiMenu, FiLogOut, FiUser } = FiIcons;

function Header({ onMenuClick }) {
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    if (confirm('Möchten Sie sich wirklich abmelden?')) {
      await logout();
    }
  };

  // Safely get user properties with fallbacks
  const userName = user?.full_name || user?.email || 'Unbekannter Benutzer';
  const userRole = user?.role || 'user';

  return (
    <header className="bg-white fixed w-full top-0 z-50 neu-element">
      <div className="flex items-center justify-between px-6 py-4">
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="p-2 rounded-lg neu-button lg:hidden"
          >
            <SafeIcon icon={FiMenu} className="w-6 h-6 text-gray-600" />
          </button>
          
          <div className="flex items-center space-x-3">
            {/* Logo */}
            <img 
              src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759820326245-icon%20transparent.png" 
              alt="HelmPlanner Logo" 
              className="h-10 w-auto"
            />
            <div>
              <h1 className="text-2xl font-bold text-gray-900">HelmPlanner</h1>
              <p className="text-xs text-gray-500">SGM Dienstplangenerator</p>
            </div>
          </div>
        </div>

        <div className="flex items-center space-x-4">
          {/* Department Selector */}
          <DepartmentSelector />

          {/* User Info */}
          <div className="flex items-center space-x-3">
            <div className="hidden md:block text-right">
              <div className="text-sm font-medium text-gray-900">{userName}</div>
              <div className="text-xs text-gray-500">
                {userRole === 'admin' ? 'Administrator' : 'Benutzer'}
              </div>
            </div>
            <div className="w-8 h-8 neu-element rounded-full flex items-center justify-center">
              <SafeIcon icon={FiUser} className="w-4 h-4 text-orange-600" />
            </div>
            <button
              onClick={handleLogout}
              className="p-2 rounded-lg neu-button text-gray-600 hover:text-red-600"
              title="Abmelden"
            >
              <SafeIcon icon={FiLogOut} className="w-5 h-5" />
            </button>
          </div>

          <span className="text-sm text-gray-600 p-2 rounded-lg neu-element-inset">
            {new Date().toLocaleDateString('de-DE', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })}
          </span>
        </div>
      </div>
    </header>
  );
}

export default Header;